import { makeStyles } from '@material-ui/styles'

const showTicketStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1.6),
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'auto',
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1.6),
  },
  iconButton: {
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
    marginBottom: theme.spacing(0.8),
  },
  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    color: theme.palette.common.white,
  },
  buttonsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  newTicketButton: {
    marginLeft: 'auto',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    height: 44,
  },
  title: {
    marginBottom: theme.spacing(0.8),
  },
  subTitle: {
    marginBottom: theme.spacing(3.2),
  },
  downloadButton: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4.0),
    height: 56,
  },
  gridContainer: {
    marginTop: theme.spacing(4.0),
  },
  img: {
    width: '100%',
    marginTop: theme.spacing(2.4),
    marginBottom: theme.spacing(4.0),
  },
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  textField: {
    marginTop: theme.spacing(1.6),
    marginBottom: theme.spacing(2.4),
  },
  datePicker: {
    marginTop: theme.spacing(2.4),
    marginBottom: theme.spacing(2.4),
  },
  boldFont: {
    fontWeight: theme.typography.fontWeightBold,
  },
  form: {
    width: '100%',
  },
}))

export default showTicketStyles
